<template>

	<div class="rechargeManager">
		<input name="" id="Endtime" style="display:none"/>
		<div class="crumbs">

		    <el-breadcrumb separator=">">
		      <!--<el-breadcrumb-item :to="{ path: '/' }">当前位置</el-breadcrumb-item>-->
		      <span style="float: left;font-size: 100%;font-weight: 700;">当前位置&nbsp;:&nbsp;</span>
			  <el-breadcrumb-item>财务管理</el-breadcrumb-item>
			  <el-breadcrumb-item>广告主充值申请</el-breadcrumb-item>
			</el-breadcrumb>

		</div>
		<div class="form-list-argument">
			<!--这里放一个input是为了解决自动补全的bug-->

			<ul>
				<li>
					<label style="">广告主ID：</label>
		        	<el-select
		        		style="width: 220px;"
		        		class="user-id"
					    v-model="inputID"
					    clearable
					    filterable
					    remote
					    reserve-keyword
					    collapse-tags
					    placeholder="请输入关键词"
					    :remote-method="remoteMethod"
					    :loading="inploading">
					    <el-option
					    style="width: 220px;"
					      v-for="item in options4"
					      :key="item.id"
					      :label="item.id"
					      :value="item.id">
					      <span >[{{ item.id }}]</span>
        				  <span >{{ item.name }}</span>
					    </el-option>
					</el-select>
			    </li>
				<li style="margin-left: 15px;">
		        	<label style="">公司名称：</label>
			        <el-input v-model="inputName" placeholder="请输入"></el-input>
			    </li>
			    <li style="margin-left:-15px;">
		        	<label style="">销售：</label>
			        <el-select v-model="saleName" filterable  placeholder="全部状态">
			            <el-option
			                v-for="item in saleNameArr"
			                :key="item.id"
			                :label="item.name"
			                :value="item.id">
			            </el-option>
			        </el-select>
			    </li>
			    <li style="margin-left:15px;margin-right: 10px;">
		        	<label style="">审核状态：</label>
			        <el-select v-model="status" filterable  placeholder="全部状态">
			            <el-option
			                v-for="item in statusArr"
			                :key="item.value"
			                :label="item.label"
			                :value="item.value">
			            </el-option>
			        </el-select>
			    </li>
			    <li style="min-width: 370px;">
		        	<label style="margin-top: 5px;">添加时间：</label>
			        <el-date-picker class = "timepicker" v-model="datetime"   value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
			    </li>

			    <li class="libtn">
		        	<el-button type="primary"  @click="searchrechargeList">搜索</el-button>
		        	<el-button type="primary"  @click="rechargeExport">导出数据</el-button>

		        </li>
		        <input placeholder="结束日期" name="" class="el-range-input" style="display: none;">
			</ul>

		</div>

		<!--数据切换按钮-->
		<div class="changedata">
			<span class="iconfont el-icon-shuju touxiang"></span>
			<span class="pronum">广告充值管理(共{{totalCount}}条)</span>
		</div>

		<!--表格部分-->
		<div>
			<template>
			    <el-table
			      v-loading="loading"
			      :data="tableData"
			      style="width: 100%">
			      <el-table-column  label="操作" align="center">
			      	  <template slot-scope="scope">
			      	  		<span href="" class="operate" @click="openAuditingDialog(scope.row)">通过</span><br />
			      	  		<span href="" class="operate" @click="rejectOpenDialog(scope.row)">驳回</span><br />
			      	  		<span href="" class="operate" @click="showRecordDialog(scope.row)">修正记录</span>
			      	  </template>
			      </el-table-column>
			      <el-table-column prop="UserName" label="打款凭据" width="195" align="center">
			      		<template slot-scope="scope">
			              <img class="activity-banner" :src="activityBanner(scope.row.PaymentVoucherPic)">
			            </template></el-table-column>
			      <el-table-column label="审核状态" min-width="90" align="center">
			      		<template slot-scope="scope">{{scope.row.Status | statusMethod}}</template>
			      </el-table-column>
			      <el-table-column prop="UserId" min-width="90" label="广告主ID" align="center"></el-table-column>
			      <el-table-column prop="SalesManName" label="销售" align="center">
			      		<template slot-scope="scope">
			              <a style="color: #5798D7;" href="javascript:void(0)" @click="showsaledialog(scope.row)">{{scope.row.SalesManName}}</a>
			            </template>
			      </el-table-column>
			      <el-table-column prop="CompanyName" min-width="90" label="公司名称" align="center"></el-table-column>
			      <el-table-column prop="BeforeBalance" min-width="100" label="充值前余额" align="center">
			      		<template slot-scope="scope">{{scope.row.BeforeBalance | tofixed2}}</template>
			      </el-table-column>
			      <el-table-column  min-width="100" label="充值金额" align="center">
			      		<template slot-scope="scope">
			      			<div  @click="editdialog(scope.row)">
			      				<span :class="{ activeClass : scope.row.CorrectRechargeAmount > -1 }">{{scope.row.RechargeAmount | tofixed2}}</span><br />
				      			<span v-if="scope.row.CorrectRechargeAmount >= 0">{{scope.row.CorrectRechargeAmount | tofixed2}}</span>
				      			<span class="el-icon-edit" style="color: #7EC8E0;"></span>
			      			</div>

			      		</template>
			      </el-table-column>
			      <el-table-column prop="ActivityId" min-width="110" label="返点金额" align="center">
			      		<template slot-scope="scope">
			      			<div @click="editdialog(scope.row)">
			      				<span :class="{ activeClass : scope.row.CorrectRebateAmount > -1}">{{scope.row.RebateAmount | tofixed2}}</span><br />
				      			<span v-if="scope.row.CorrectRebateAmount >= 0">{{scope.row.CorrectRebateAmount | tofixed2}}</span>
				      			<span class="el-icon-edit" style="color: #7EC8E0;" ></span>
			      			</div>
			      		</template>
			      </el-table-column>
			      <el-table-column min-width="100" label="充值后余额" align="center">
			      		<template slot-scope="scope">{{scope.row.AfterBalance | tofixed2}}</template>
			      </el-table-column>
			      <el-table-column label="发票类型" min-width="90" align="center">
			      		<template slot-scope="scope">{{scope.row.InvoiceType | InvoiceType}}</template>
			      </el-table-column>
			      <el-table-column min-width="250" show-overflow-tooltip label="发票信息" align="center">
			      		<template slot-scope="scope">
			      			<span>{{scope.row.EnterpriseName}}</span><br />
			      			<span>{{scope.row.TaxpayerIdentifNum}}</span><br />
			      			<span>{{scope.row.BranchBankInfo}}</span><br />
			      			<span>{{scope.row.BankAccount}}</span><br />
			      			<span>{{scope.row.LinkAddress}}</span>
			      		</template>

			      </el-table-column>
			      <el-table-column label="打款时间" min-width="110" align="center">
			      	<template slot-scope="scope">{{scope.row.PayDate | tableDate("no")}}</template>
			      </el-table-column>
			      <el-table-column label="审核时间" min-width="160" align="center">
			      	<template slot-scope="scope">{{scope.row | checkoutDate}}</template>
			      </el-table-column>
			      <el-table-column prop="AddDate"  min-width="160" label="添加时间" align="center">
			      	<template slot-scope="scope">{{scope.row.AddDate | tableDate}}</template>
			      </el-table-column>
			      <el-table-column prop="Remark" label="备注" align="center"></el-table-column>
			    </el-table>
			</template>
			<div class="pagination"  align="center">
				<el-pagination
				  @current-change="handleCurrentChange"
		          :current-page="currentPage"
		          :page-size="20"
				  background
				  layout="prev, pager, next"
				  :total="totalCount">
				</el-pagination>
			</div>
		</div>

		<!--修改记录弹窗-->
		<el-dialog
		  title="金额修正记录"
		  v-loading="loading2"
		  element-loading-text="拼命加载中"
		  element-loading-spinner="el-icon-loading"
		  element-loading-background="rgba(0, 0, 0, 0.8)"
		  :visible.sync="recordDialog"
		  width="960px"
		  center>
		  <ul class="recordUl" :class="{isLine:isshowLine}">
		  	<li>充值金额:{{amount}}</li>
		  	<li>返点金额:{{rebateAmount}}</li>
		  	<li>操作时间:{{AddDate | tableDate}}</li>
		  	<li>备注:{{remarks}}</li>
		  </ul>
		  <ul class="recordUlAfter" v-if="isshowLine" v-for="item in editrecord">
		  	<li>修正后充值金额:{{item.CorrectRechargeAmount}}</li>
		  	<li>修正后返点金额:{{item.CorrectRebateAmount}}</li>
		  	<li>操作时间:{{item.AddDate | tableDate}}</li>
		  	<li>备注:{{item.Remark}}</li>
		  </ul>
		</el-dialog>

		<!--金额修正弹窗-->
		<div class="moneydialog">
			<el-dialog
			  title="金额修正"
			  top="30vh"
			  :visible.sync="editDialog"
			  width="30%"
			  >
			  <ul class="editul">
			  	<li>
			  		<label>充值金额:</label>
			  		<el-input  size="small" placeholder="请输入内容" v-model="amount" :disabled="true"> </el-input>
			  	</li>
			  	<li>
			  		<label>修正后充值金额:</label>
			  		<el-input type="number"  size="small" placeholder="请输入修正后充值金额" v-model="editAmount" > </el-input>
			  	</li>
			  	<li>
			  		<label>返点金额:</label>
			  		<el-input  size="small" placeholder="请输入内容" v-model="rebateAmount" :disabled="true"> </el-input>
			  	</li>
			  	<li>
			  		<label>修正后返点金额:</label>
			  		<el-input  size="small" placeholder="请输入修正后返点金额" v-model="editRebateAmount" > </el-input>
			  	</li>
			  	<li>
			  		<label>备注:</label>
			  		<el-input  size="small" placeholder="请输入修改原因(限10字)" v-model="remarks" maxlength="10"> </el-input>
			  	</li>
			  	<input placeholder="结束日期" name="" class="el-range-input" style="display: none;">
			  </ul>
			  <div class="editbtn">
			  	 <el-button size="mini" @click ="editDialog = false" >取消</el-button>
			  	 <el-button size="mini" type="primary" @click="editEnd">确定</el-button>
			  </div>
			</el-dialog>
		</div>
		<!--审核弹窗-->
	    <div class="auditingdialog">
	    	<el-dialog
			  title="审核充值申请"
			  top="30vh"
			  :visible.sync="auditingDialog"
			  width="30%"
			  >
			  <ul class="editul">
			  	<li>
			  		<label>广告主ID:</label>
			  		<el-input  size="small" placeholder="请输入内容" v-model="userId" :disabled="true"> </el-input>
			  	</li>
			  	<li>
			  		<label>充值金额:</label>
			  		<el-input type="number"  size="small" placeholder="请输入内容" v-model="amount" :disabled="true"> </el-input>
			  	</li>
			  	<li>
			  		<label>返点金额:</label>
			  		<el-input  size="small" placeholder="请输入内容" v-model="rebateAmount" > </el-input>
			  	</li>
			  	<li>
			  		<label>备注:</label>
			  		<el-input  size="small" placeholder="请输入修改原因(限10字)" v-model="throughRemark" maxlength="10"> </el-input>
			  	</li>
			  	 <input placeholder="结束日期" name="" class="el-range-input" style="display: none;">
			  </ul>
			  <div class="editbtn">
			  	 <el-button size="mini" @click="auditingDialog = false" >取消</el-button>
			  	 <el-button size="mini" type="primary" @click="throughEnd">确定</el-button>
			  </div>
			</el-dialog>

			<!--驳回申请弹窗-->
			<el-dialog
			  title="审核充值申请"
			  top="30vh"
			  :visible.sync="rejectDialog"
			  width="30%"
			  >
			  <ul class="editul">
			  	<li>
			  		<label>广告主ID:</label>
			  		<el-input  size="small" placeholder="请输入内容" v-model="userId" :disabled="true"> </el-input>
			  	</li>
			  	<li>
			  		<label>充值金额:</label>
			  		<el-input type="number"  size="small" placeholder="请输入内容" v-model="amount" :disabled="true"> </el-input>
			  	</li>
			  	<li>
			  		<label>备注:</label>
			  		<el-input  size="small" placeholder="请输入修改原因(限10字)" v-model="rejectRemark" maxlength="10"> </el-input>
			  	</li>
			  	<input placeholder="结束日期" name="" class="el-range-input" style="display: none;">
			  </ul>
			  <div class="editbtn">
			  	 <el-button size="mini" @click="rejectDialog = false" >取消</el-button>
			  	 <el-button size="mini" type="primary" @click="rejectEnd" >确定</el-button>
			  </div>
			</el-dialog>
			<!--修改销售人员对话框-->
			<div class="salebox">
				<el-dialog
				  top="30vh"
				  title="修改销售人员"
				  :visible.sync="editsale"
				  width="30%"
				  center>
				  <div class="salediv">
					    <label style="">销售人员：</label>
				        <el-select v-model="editSaleName" filterable  placeholder="全部状态">
				            <el-option
				                v-for="item in UserAdOperatorUser"
				                :key="item.id"
				                :label="item.name"
				                :value="item.id">
				            </el-option>
				        </el-select>
				  </div>

				  <span slot="footer" class="dialog-footer">
				    <el-button @click="editsale = false">取 消</el-button>
				    <el-button type="primary" @click="editsaleMethod">确 定</el-button>
				  </span>
				</el-dialog>
			</div>
	    </div>

	</div>

</template>

<script>
	import {rechargeList} from 'api/rechargeWithRefund'   //获取充值申请列表
	import {IADAdrRechargeExport} from 'api/rechargeWithRefund'  //充值申请列表导出
	import {pass} from 'api/rechargeWithRefund'  //通过驳回接口
	import {GetSalesman} from 'api/rechargeWithRefund'     //获取销售人接口
	import {recordList} from 'api/rechargeWithRefund'     //获取修正记录接口
	import {CheckMoney} from 'api/rechargeWithRefund'     //修改充值金额接口
	import {GetUser} from "api/advertiser";
	import {GetDialogSalesman} from "api/rechargeWithRefund";     //获取弹窗销售人员列表
	import {UpdateSalesMan} from "api/rechargeWithRefund";     //修改弹窗人员接口
	export default {
    	  data() {
	      return {
	      	searchData:{
	      		AdOperatorName:""
	      	},
	      	BusinessId:"",        //保存维修人员是的业务id
	      	editSaleName:"",      //按销售人员id
	      	UserAdOperatorUser:[],//销售人员列表
	      	editsale:false,       //修改销售人员对话框
	      	list:[],
	      	inploading:false,    //id加载中
	      	options4:[],		 //id的数组
	      	loading: true,       //加载中
	      	loading2:true,		 //控制修正记录弹窗的加载
	      	inputID:"",
	      	inputName:"",
	      	saleName:"",         //销售人
	      	saleNameArr:[ 		  //销售人数组

	      	],
	      	status:"",           //审核状态
	      	statusArr:[			//审核状态数组
	      		{
	      			value:"",
	      			label:"全部状态"
	      		},
	      		{
	      			value:-1,
	      			label:"已拒绝"
	      		},{
	      			value:0,
	      			label:"审核中"
	      		},
	      		{
	      			value:1,
	      			label:"已通过"
	      		}
	      	],
 	      	datetime:"",         //添加时间
	      	tableData:[],
	      	recordDialog:false,   //修改记录弹窗
	      	editDialog:false,      //金额修正弹窗
	      	auditingDialog:false,  //审核弹窗
	      	rejectDialog:false,    //驳回弹窗
	      	amount:"",     //充值金额
	      	editAmount:"",     //修正后充值金额
	      	rebateAmount:"",  //返点金额
	      	editRebateAmount:"", //修正后返点金额
	      	remarks:"",        //  备注
	      	userId:"1101",            //广告主ID
	      	BusinessId:"",        //业务ID
	      	throughRemark:"",      //审核备注
	      	currentPage:1,         //当前页数
	      	totalCount:null,        //总条数
	      	time:"",
	      	rejectRemark:"",         //驳回备注
	      	aftermoney:"",          //修正后金额
	      	afterrefunmoney:"",      //修正后返点金额
	      	AddDate:"",             //修正记录弹窗的历史操作时间
	      	editrecord:[],			//修正记录弹窗的修正后的参数
	      	isshowLine:true,        //是否显示弹窗记录的中划线
	      }
	    },
		methods:{
			showsaledialog(datas){
				console.log(datas);
				this.editsale = true
				this.editSaleName = datas.SalesMan;
				this.BusinessId = datas.BusinessId
			},
			editsaleMethod(){
				console.log(this.editSaleName);
				this.UpdateSalesMan();
			},
			UpdateSalesMan(){
				UpdateSalesMan({
					businessId:this.BusinessId,
					salesMan:this.editSaleName
				}).then(res=>{
					this.open4("更新成功");
					this.editsale = false;
					this.rechargeList();
				})
			},
			remoteMethod(query) {
		        if (query !== '') {
		          this.inploading = true;
		          GetUser({
				        name: query, userType: 1
				  }).then(res => {
				  		this.inploading = false;
						this.list = res.list.map(item => {
					        return { value: item, label: item };
					    });
				     	this.options4 = res.list
				  })

		        } else {
		          this.options4 = [];
		        }
	        },
			showRecordDialog(rows){
				this.recordDialog = true;
				this.BusinessId = rows.BusinessId;    //业务id
				this.amount = rows.RechargeAmount;    //点击通过，为中值金额赋值
				this.rebateAmount = rows.RebateAmount;//点击通过，为返点金额赋值
				this.aftermoney = rows.CorrectRechargeAmount;
				this.afterrefunmoney = rows.CorrectRebateAmount;
				this.AddDate = rows.AddDate;
				this.remarks = rows.Remark
				this.recordList();
			},
			recordList(){		//获取修正记录
				recordList({
					AdrRechargeId:this.BusinessId
				}).then(res=>{
//					this.loading2 =false;
					if(res.length == 0){   //证明该条数据没有修改过
						this.isshowLine = false;
						this.editrecord = [];   //需要将数组置空，否则下次复制后不会改变视图
						return
					}
					this.isshowLine = true;
					this.editrecord = res;
				})
			},
			rejectOpenDialog(rows){     //开启驳回弹窗，并获取对应值
				if(rows.Status == -1 || rows.Status == 1){     //证明是已经通过货已经拒绝的，就不在网下执行
					this.open3("只有审核中状态的充值申请才可以审核或驳回")
					return
				}
				this.rejectRemark = "";
				this.rejectDialog = true;
				this.BusinessId = rows.BusinessId;    //点击通过，为业务ID赋值
				this.userId = rows.UserId; 			  //点击通过，为广告主ID赋值
				this.amount = rows.RechargeAmount;    //点击通过，为中值金额赋值
			},
			rejectEnd(){        //驳回确定按钮
	 			pass({
					BusinessId:this.BusinessId,
					UserId:this.userId,
					Status:-1,
					RechargeAmount:this.amount,
					Remark:this.rejectRemark
				}).then(res=>{
					this.rechargeList();
					this.open4("已驳回")
					this.rejectDialog = false;
				})
			},
			activityBanner(banner) {     //设置banner图
		        return `//static.adjuz.com/${banner}`
		    },
			rechargeExport(){     //导出数据
				if(this.datetime == null){
					this.datetime = ""
				}
              	window.location.href="/iadadrrecharge/IADAdrRechargeExport?UserId="+this.inputID + "&BeginDate=" + (this.datetime[0] || this.time) + "&EndDate=" + (this.datetime[1] || this.time) + "&CompanyName=" + this.inputName + "&SalesMan=" + this.saleName + "&Status=" + this.status;
			},
			handleCurrentChange(val){    //选定第几页
                    this.currentPage = val;
                    this.rechargeList()
            },
			openAuditingDialog(rows){   //点击打开审核弹窗 ,获取该条申请对应的信息
				if(rows.Status == -1 || rows.Status == 1){     //证明是已经通过货已经拒绝的，就不在网下执行
					this.open3("只有审核中状态的充值申请才可以审核或驳回")
					return 
				}
				this.throughRemark = "";   //将上次的输入框的值清除掉
				this.auditingDialog = true;
				this.BusinessId = rows.BusinessId;    //点击通过，为业务ID赋值
				this.userId = rows.UserId; 			  //点击通过，为广告主ID赋值
				this.amount = rows.RechargeAmount;    //点击通过，为中值金额赋值
				this.rebateAmount = rows.RebateAmount;//点击通过，为返点金额赋值
			},
			throughEnd(){
				if(this.amount == 0 && this.rebateAmount == 0){
					this.open3("充值金额和返点金额不可同时为0,请重新输入");
					return false
				}
				if(this.rebateAmount <0 ){
					this.open3("返点金额不能为负数，请重新输入");
					return false
				}
//				if(typeof(this.rebateAmount) == "string"){
//					this.open3("请输入数字");
//					return false
//				}
//				发起审核请求
				pass({
					BusinessId:this.BusinessId,
					UserId:this.userId,
					Status:1,
					RechargeAmount:this.amount,
					RebateAmount:this.rebateAmount,
					Remark:this.throughRemark
				}).then(res=>{
					this.rechargeList();
					this.open4("审核通过")
					this.auditingDialog = false;
				})

			},
			editEnd(){    //点击确定，  关闭金额修正弹窗
//				editAmount,editRebateAmount
				const editDialog = this.editAmount;
				const editRebateAmount = this.editRebateAmount;
				const isTrue = this.isNumber(editDialog,editRebateAmount);
				if(this.amount == editDialog && this.rebateAmount == editRebateAmount){
					this.open3("修正后充值金额/返点金额无变化，请核对后再操作");
					return false;
				}
				console.log(this.amount)
				console.log(editDialog)
				if(this.amount == editDialog && this.editRebateAmount == ""){
					this.open3("修正后充值金额金额无变化，请核对后再操作");
					return false;
				}
				if(editDialog == "" && this.rebateAmount == editRebateAmount){
					this.open3("修正后返点金额无变化，请核对后再操作");
					return false;
				}
//				if(this.editAmount ==""){
//					this.open3("修正后充值金额不能为空，请核对后再操作");
//					return false;
//				}


				if(isTrue == true){    //当isTrue为true的时候才可以继续执行
					CheckMoney({
						AdrRechargeId:this.BusinessId,
						RechargeAmount:this.amount,
						RebateAmount:this.rebateAmount,
						CorrectRechargeAmount:editDialog,
						CorrectRebateAmount:editRebateAmount,
						Remark:this.remarks
					}).then(res=>{
						console.log(res);
						if(res.result > 0){
							this.open4("修改成功");
							this.rechargeList();
							this.editDialog = false;
						}else if(res.result == 0){
							this.open3("请输入正确格式的金额,并且不能输入标点符号")
						}else if(res.result == -1){
							this.open3("改广告主下有开启的投放计划，不能减少余额")
						}else if(res.result == -2){
							this.open3("可用现金余额不足，不能减少余额")
						}else if(res.result == -3){
							this.open3("可用返货余额不足，不能减少余额")
						}else if(res.result == -4){
							this.open3("修正失败")
						}else if(res.result == -7){
							this.open3("异常出错")
						}else if(res.result == -10){
							this.open3("当前广告主存在退款申请，无法进行金额修正")
						}else{
							this.open3("未知错误")
						}
					})
				}

			},
			editdialog(rows){     //点击打开    金额修正弹窗
//				先将输入框的值置空
				this.editAmount= "";
				this.editRebateAmount = "";
				this.remarks = "";
				if(rows.Status == -1){
					this.open3("已拒绝的充值申请暂不支持修改");
					return
				}
				if(rows.Status == 0){
					this.open3("审核中的充值申请不支持修改");
					return
				}
				console.log(rows.CorrectRebateAmount);
				if(rows.CorrectRechargeAmount == -1){
					this.amount = rows.RechargeAmount;    //点击通过，为中值金额赋值
					this.rebateAmount = rows.RebateAmount;//点击通过，为返点金额赋值
				}else{
					this.amount = rows.CorrectRechargeAmount;    //点击通过，为中值金额赋值
					this.rebateAmount = rows.CorrectRebateAmount;//点击通过，为返点金额赋值
				}
				this.BusinessId = rows.BusinessId;
				this.editDialog = true;

			},
			isNumber(num1,num2){    //判断是不是字符创以及是不是负数
				var reg1 = /^\d+(\.\d{1,2})?$/;
				if(num1<0 ){     //判断不能输入负数
					this.open3("修正后充值金额不能为负数，请重新输入");
					return false
				}
				if(num2<0){
					this.open3("修正后返点金额不能为负数，请重新输入");
					return false
				}
				
				
				if((num1.toString()).indexOf(".") != -1){
					if(!reg1.test(num1)){
						this.open3("输入值请保留小数点后两位");
						return false
					}
					
				}
				if((num2.toString()).indexOf(".") != -1){
					if(!reg1.test(num2)){
						this.open3("输入值请保留小数点后两位");
						return false
					}
				}
				var reg = /^[\+\-]?\d*?\.?\d*?$/;
				if(num1 != ""){
					if(reg.test(num1) == false){
						this.open3("请输入数字");
						return false
					}
				}
				if(num2 != ""){
					if(reg.test(num2) == false){
						this.open3("请输入数字");
						return false
					}
				}

				return true
			},
			open3(mes) {         //输入内容有提示
		        this.$message({
		          message: mes,
		          type: 'warning'
		        });
		    },
		    open4(mes){
		    	this.$message({
		          message: mes,
		          type: 'success',
		          center: true
		        });
		    },
		    rechargeList(){    //获取广告主充值列表接口
		    	if(this.datetime == null){
		    		this.datetime = []
		    	}
		    	rechargeList({
		    		UserId: this.inputID,
		    		CompanyName: this.inputName,
		    		SalesMan: this.saleName,
		    		Status:this.status,
		    		BeginDate:this.datetime[0] || "",
		    		EndDate:this.datetime[1] || "",
		    		AdOperatorName:"",
		    		PageIndex:this.currentPage
		    	}).then(res=>{
		    		console.log(res);
		    		this.loading = false;    //将loading关闭
		    		this.totalCount = res.TotalNum;
		    		this.tableData = res.Items
		    	})
		    },
		    searchrechargeList(){    //获取广告主充值列表接口
		    	if(this.datetime == null){
		    		this.datetime = []
		    	}
		    	this.currentPage =1;
		    	rechargeList({
		    		UserId: this.inputID,
		    		CompanyName: this.inputName,
		    		SalesMan: this.saleName,
		    		Status:this.status,
		    		BeginDate:this.datetime[0] || "",
		    		EndDate:this.datetime[1] || "",
		    		AdOperatorName:"",
		    		PageIndex:this.currentPage
		    	}).then(res=>{
		    		console.log(res);
		    		this.loading = false;    //将loading关闭
		    		this.totalCount = res.TotalNum;
		    		this.tableData = res.Items
		    	})
		    },
		    GetSalesman(){      //获取销售人列表
		    	GetSalesman().then(res=>{
		    		console.log(res);
		    		this.saleNameArr = res.list;
		    		this.saleNameArr.unshift(
		    			{
		    				id:"",
		    				name:"全部销售"
		    			}
		    		)
		    	})
		    },
		    GetDialogSalesman(){
		    	GetDialogSalesman().then(res=>{
		    		console.log(res);
					for(var i = 0;i<res.length;i++){
						this.UserAdOperatorUser.push({
							id: res[i].UserId,
							name: res[i].UserName
						})
					}
					console.log(this.UserAdOperatorUser)
		    	})

		    }
		},
		created () {
//			var tabledata = [{"Title":"假数据","ActivityId":"test","UserName":"比测试","TempName":"模板名号","SourceRange":"媒体"}]
			this.GetDialogSalesman()  //获取弹窗中的销售人员列表
			this.rechargeList()   //获取光盖住充值列表
			this.GetSalesman()    //获取销售人列表
		},
		filters: {
			   tableDate(date,x) {  //过滤日期
		        if (date) {
		          let timeSpan = date.replace(/(\/Date)|\/|\(|\)|\//ig, '');
		          let dates = new Date(parseInt(timeSpan));
		          let year = dates.getFullYear()
		          let month = dates.getMonth() + 1 > 9 ? dates.getMonth() + 1 : '0' + (dates.getMonth() + 1);
		          let day = dates.getDate() > 9 ? dates.getDate() : '0' + dates.getDate();
		          let hours = dates.getHours() > 9 ? dates.getHours() : '0' + dates.getHours();
		          let minutes = dates.getMinutes() > 9 ? dates.getMinutes() : '0' + dates.getMinutes();
		          let seconds = dates.getSeconds() > 9 ? dates.getSeconds() : '0' + dates.getSeconds();
//		           	 为了满足测试要求只要是1900年一月一号就返回空
				  if(year + '-' + month + '-' + day == "1900-01-01"){
				  	 return ""
				  }
		          if(x){
		          		return year + '-' + month + '-' + day
		          }else{
		          		return year + '-' + month + '-' + day + " " + hours + ":" + minutes+ ":" + seconds
		          }

		        } else {
		          return '';
		        }
		      },
		      checkoutDate(datas,x){       //为了判断审核时间，当状态为审核中的时候，不显示时间
		      	const date = datas.RechargeDateTime;
		      	if(datas.Status == 0){   //证明是审核中 只返回空就可以
					return ""
		      	}
		      	if (date){
		          let timeSpan = date.replace(/(\/Date)|\/|\(|\)|\//ig, '');
		          let dates = new Date(parseInt(timeSpan));
		          let year = dates.getFullYear()
		          let month = dates.getMonth() + 1 > 9 ? dates.getMonth() + 1 : '0' + (dates.getMonth() + 1);
		          let day = dates.getDate() > 9 ? dates.getDate() : '0' + dates.getDate();
		          let hours = dates.getHours() > 9 ? dates.getHours() : '0' + dates.getHours();
		          let minutes = dates.getMinutes() > 9 ? dates.getMinutes() : '0' + dates.getMinutes();
		          let seconds = dates.getSeconds() > 9 ? dates.getSeconds() : '0' + dates.getSeconds();
		          return year + '-' + month + '-' + day + " " + hours + ":" + minutes+ ":" + seconds
		        } else {
		          return '';
		        }
		      },
		      statusMethod(status){   // 状态转换
		      	if(status == 0){
		      		return "审核中"
		      	}
		      	if(status == 1){
		      		return "已通过"
		      	}
		      	if(status == -1){
		      		return "已拒绝"
		      	}
		      },
		      InvoiceType(types){     //发票类型
		      	if(types == 0){
		      		return "普通"
		      	}
		      	if(types == 1){
		      		return "专用"
		      	}
		      	if(types == 2){
		      		return "不开票"
		      	}
		      }
		}

	}
</script>

<style lang="scss">
	.rechargeManager{
		/*padding: 0 15px;*/
	}

	.touxiang{

		color: #D9D9D9;
	}
	.operate{
		color:rgb(114, 172, 227) ;
		font-size: 14px;
		cursor: pointer;
	}
	/*记录弹窗样式*/
	.recordUl, .recordUlAfter{
		border-bottom: 1px solid #F5F5F5;
		height: 60px;
		line-height: 60px;
	}
	.rechargeManager .recordUl li,.recordUlAfter li{
		float: left;
		width: 25%;
		text-align: center;
		span{
			width: 50%;
			text-align: right;
			display: inline-block;
		}

	}
	.rechargeManager .recordUlAfter li{
		text-decoration: line-through;
	}
	.rechargeManager .isLine li{
		text-decoration: line-through;
	}
	.recordUlAfter:last-child li{
		text-decoration: none !important;
		color: #FFB13E;
	}

	/*金额修正弹窗样式*/
	.editul{
		margin-top: 20px;
	}
	.editul li{
		margin-bottom: 10px;
		label{
			display: inline-block;
			width: 120px;
			text-align: right;
		}
	}
	/*确定按钮*/
	.editbtn{
		text-align: center;
		margin-top: 30px;
	}
	/*筛选条件样式*/
	.form-list-argument {
		border: 1px solid #f5f5f5;
		margin-top: 20px;
		padding-top: 30px;
		padding-bottom: 20px;
	    ul:after {
	      content: '';
	      display: block;
	      clear: both;
	    }
	    ul {
	      padding-left:10px ;
		  .libtn{
		  		margin-left:180px;
		  		button{
		  			height: 34px;
		  			line-height: 0;
		  		}
		  }
	      li {
	      	.timepicker{
		  		position: relative;
		  		max-width: 250px;
		  	}
	      	position: relative;
	        float: left;
	        /*width: 20%;*/
	        height: 50px;
	        label {
	          display: inline-block;
	          width: 85px;
	          text-align: right;
	        }
	        .el-input {
	          min-width:60%;
	          max-width: 160px;
	        }
	        .el-input:nth-child(3){
	        	width: 100%;
	        }
	        .el-button {
	          background: cornflowerblue;
	          color: #ffffff;
	          margin-left: 10px;
	        }
	        .el-select {
	          width: 60%;
	          &.user-id {
	          	.el-input__inner {
	          		width: 220px;
	          	}
	          	.el-input__suffix{
	          		left: 120%;
	          	}
	          }
	        }
	      }
	    }
  	}

  	.changedata{
  		margin-top: 10px;
  		margin-bottom: 10px;
  		.icon{
  			color: #BBBBBB;
  			position: relative;
  		}
  		.pronum{
  			margin-right: 10px;
  		}
  		button{
  			line-height: 1px;
  			padding-left:10px;
  			padding-right: 10px;
  			font-size: 12px;
  			color: black;
  		}
  	}
  	/*分页样式*/
  	.rechargeManager .pagination{
  		margin-top: 20px;
		display: block !important;
	}
	.rechargeManager .crumbs{
    	margin-top: 10px; padding: 10px 10px 10px 8px; border-left: 2px solid #bbb; background: #f5f5f5;
    }
  	.rechargeManager .activity-banner {
	    max-width: 187px ;
	    max-height: 82px;
	    border: none;
	}
	.activeClass{
		text-decoration: line-through;
		color: #FFB13E;
		display: block;
	}
	/*销售人员弹窗*/
	.rechargeManager .salediv{
		position: relative;
    	top: 35px;
   		text-align: center;
	}
	.rechargeManager .salediv label{
		line-height: 32px;
		font-weight: 600;
	}
	.rechargeManager .salebox .el-dialog__header{
		 background: #5798D7;
	}
	.rechargeManager .salebox .el-dialog__title , .rechargeManager .salebox .el-dialog__close{
		color: white;
	}
	.rechargeManager .salebox .el-dialog--center .el-dialog__body{
		padding: 0 !important;
		padding-bottom: 50px !important;
	}
</style>
<style>
	/*修改记录弹窗样式*/
	.rechargeManager .el-dialog__header{
		background: #F9F8F8;
		border-bottom: 1px solid #DCDCDC;

	}
	.rechargeManager .el-dialog__body{
		padding: 0;
		padding-bottom: 50px;
		max-height: 400px;
    	overflow-y: auto;
	}
	.moneydialog .el-dialog,.auditingdialog .el-dialog{
		min-width: 430px;
	}
	.editul .el-input{
		width: 50%;
	}
	.rechargeManager .el-range-separator{
		width: 10% !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/financial-management/rechargeManager.vue